import { Ionicons, Entypo } from '@expo/vector-icons'
import { createStackNavigator } from '@react-navigation/stack'
import { Icon, useTheme, HStack } from 'native-base'
import React from 'react'
import LocalizationContext from '../context/LocalizationContext'
import CreditListScreen from '../screens/Main/CreditListScreen'
import EditCreditScreen from '../screens/Main/EditCreditScreen'
import HomeScreen from '../screens/Main/HomeScreen'
import MemberCreditListScreen from '../screens/Main/MemberCreditListScreen'
import MemberDetailScreen from '../screens/Main/MemberDetailScreen'
import MemberListScreen from '../screens/Main/MemberListScreen'
import MemberOrderListScreen from '../screens/Main/MemberOrderListScreen'
import OrderDetailScreen from '../screens/Main/OrderDetailScreen'
import OrderListScreen from '../screens/Main/OrderListScreen'
import ReservationCalendarScreen from '../screens/Main/ReservationCalendarScreen'
import ReservationListScreen from '../screens/Main/ReservationListScreen'
import UserCouponDetailScreen from '../screens/Main/UserCouponDetailScreen'
import AsyncStorage from '@react-native-community/async-storage';
const MainStack = createStackNavigator()

function MainNavigator(props) {
    const { t } = React.useContext(LocalizationContext)
    const { colors } = useTheme()
    console.log(colors)

    const handleOnLogoutPress = async () => {
        try {
            await AsyncStorage.removeItem('@token')
            await AsyncStorage.removeItem('@tokenExpAt')
            return props.navigation.navigate('Auth')
        }
        catch (e) {
            console.log(e)
        }
    }

    return (
        <MainStack.Navigator
            screenOptions={{
                headerStyle: { backgroundColor: colors['primary']['100'], shadowColor: 'transparent' },
                headerTitleStyle: { color: colors['white'] }
            }}
        >
            <MainStack.Screen
                name={'Home'}
                component={HomeScreen}
                options={{
                    headerLeft: () => {
                        return <Icon name={'log-out'} as={Entypo} color={colors['white']} size={'sm'} mx={6} onPress={() => { handleOnLogoutPress() }} />
                    },
                    headerRight: () => {
                        return (
                            <HStack mx={4}>
                                <Icon name={'ticket'} as={Entypo} color={colors['white']} size={'sm'} mx={2} onPress={() => { props.navigation.navigate('QR', { screen: 'QRScanner', params: { type: 'UserCouponDetail' } }) }} />
                                <Icon name={'qr-code'} as={Ionicons} color={colors['white']} size={'sm'} mx={2} onPress={() => { props.navigation.navigate('QR', { screen: 'QRScanner', params: { type: 'MemberDetail' } }) }} />
                            </HStack>
                        )
                    },
                    headerTitle: null
                }}
            />
            <MainStack.Screen
                name={'MemberList'}
                component={MemberListScreen}
                options={{
                    headerLeft: () => {
                        return <Icon name={'arrow-back'} as={Ionicons} color={colors['white']} size={'sm'} mx={6} onPress={() => { props.navigation.pop() }} />
                    },
                    headerRight: () => {
                        return <Icon name={'qr-code'} as={Ionicons} color={colors['white']} size={'sm'} mx={6} onPress={() => { props.navigation.navigate('QR', { screen: 'QRScanner', params: { type: 'MemberDetail' } }) }} />
                    },
                    headerTitle: t('MemberList')
                }}
            />
            <MainStack.Screen
                name={'MemberDetail'}
                component={MemberDetailScreen}
                options={{
                    headerLeft: () => {
                        return <Icon name={'arrow-back'} as={Ionicons} color={colors['white']} size={'sm'} mx={6} onPress={() => { props.navigation.pop() }} />
                    },
                    headerTitle: t('MemberDetail')
                }}
            />
            <MainStack.Screen
                name={'OrderList'}
                component={OrderListScreen}
                options={{
                    headerLeft: () => {
                        return <Icon name={'arrow-back'} as={Ionicons} color={colors['white']} size={'sm'} mx={6} onPress={() => { props.navigation.pop() }} />
                    },
                    headerTitle: t('OrderList')
                }}
            />
            <MainStack.Screen
                name={'OrderDetail'}
                component={OrderDetailScreen}
                options={{
                    headerLeft: () => {
                        return <Icon name={'arrow-back'} as={Ionicons} color={colors['white']} size={'sm'} mx={6} onPress={() => { props.navigation.pop() }} />
                    },
                    headerTitle: t('OrderDetail')
                }}
            />
            <MainStack.Screen
                name={'ReservationList'}
                component={ReservationListScreen}
                options={{
                    headerLeft: () => {
                        return <Icon name={'arrow-back'} as={Ionicons} color={colors['white']} size={'sm'} mx={6} onPress={() => { props.navigation.pop() }} />
                    },
                    headerTitle: t('ReservationList')
                }}
            />
            <MainStack.Screen
                name={'ReservationCalendar'}
                component={ReservationCalendarScreen}
                options={{
                    headerLeft: () => {
                        return <Icon name={'arrow-back'} as={Ionicons} color={colors['white']} size={'sm'} mx={6} onPress={() => { props.navigation.pop() }} />
                    },
                    headerTitle: t('ReservationList')
                }}
            />
            <MainStack.Screen
                name={'MemberOrderList'}
                component={MemberOrderListScreen}
                options={{
                    headerLeft: () => {
                        return <Icon name={'arrow-back'} as={Ionicons} color={colors['white']} size={'sm'} mx={6} onPress={() => { props.navigation.pop() }} />
                    },
                    headerTitle: t('MemberOrderList')
                }}
            />
            <MainStack.Screen
                name={'EditCredit'}
                component={EditCreditScreen}
                options={{
                    headerLeft: () => {
                        return <Icon name={'arrow-back'} as={Ionicons} color={colors['white']} size={'sm'} mx={6} onPress={() => { props.navigation.pop() }} />
                    },
                    headerTitle: t('EditCredit')
                }}
            />
            <MainStack.Screen
                name={'MemberCreditList'}
                component={MemberCreditListScreen}
                options={{
                    headerLeft: () => {
                        return <Icon name={'arrow-back'} as={Ionicons} color={colors['white']} size={'sm'} mx={6} onPress={() => { props.navigation.pop() }} />
                    },
                    headerTitle: t('MemberCreditList')
                }}
            />
            <MainStack.Screen
                name={'CreditList'}
                component={CreditListScreen}
                options={{
                    headerLeft: () => {
                        return <Icon name={'arrow-back'} as={Ionicons} color={colors['white']} size={'sm'} mx={6} onPress={() => { props.navigation.pop() }} />
                    },
                    headerTitle: t('MemberCreditList')
                }}
            />
            <MainStack.Screen
                name={'UserCouponDetail'}
                component={UserCouponDetailScreen}
                options={{
                    headerLeft: () => {
                        return <Icon name={'arrow-back'} as={Ionicons} color={colors['white']} size={'sm'} mx={6} onPress={() => { props.navigation.pop() }} />
                    },
                    headerTitle: t('UserCouponDetail')
                }}
            />
        </MainStack.Navigator>
    )
}

export default MainNavigator